import React, { useEffect, useState } from "react";
import "./Authenticate.css";
import AuthBrandPanel from "./AuthBrandPanel";
import backArrow from "./../../../assets/img/auth-back-arrow.svg";
import FormRenderer, { ComponentMapper, FormTemplate } from "../../common/FormRenderer";
import { preventDefault } from "../../../utils/common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import { Button } from "react-bootstrap";
import { clearUserSession, useChangePassword } from "../../../backend/auth";
import PageLoader from "../../shared/PageLoader";
import { toast } from "react-toastify";
import { API_RESULT, ERROR_MESSAGES } from "../../../utils/constants";
import { LOGIN_FIELDS } from "./Authenticate.constants";
import { navigate } from "raviger";
import { getBasePath } from "../../../App";
import { AxiosError } from "axios";

function ChangePassword() {
    const [changePwdSuccess, setChangePwdSuccess] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [form, setForm] = useState<any>({});
    const [passwordError, setPasswordError] = useState<string>('');
    const { changePassword } = useChangePassword((response: any) => {
        setSubmitting(false);
        if(response instanceof AxiosError) {
            const { data } = (response || {}).response || {};
            const error = (data || {}).error || (data || {}).message || ((data || {}).errors && (data || {}).errors.join(',')) || ERROR_MESSAGES.ERROR;
            toast.error(error);
        } else {
            setChangePwdSuccess(true);
        }
    }, (error: any) => {
        setSubmitting(false);
        const { data } = (error || {}).response || {};
        error = (data || {}).error || (data || {}).message || ((data || {}).errors && (data || {}).errors.join(',')) || ERROR_MESSAGES.DEFAULT;
        toast.error(error);
    });

    function signIn(event: any) {
        preventDefault(event);
        navigate(`${getBasePath()}/`);
        window.location.reload();
    }

    const schema = {
        fields: [
            { ...LOGIN_FIELDS.RESET_TOKEN, placeholder: 'Enter Reset Token', className: 'ciel-auth-field' },
            { ...LOGIN_FIELDS.NEW_PASSWORD, placeholder: 'Enter new password', className: 'ciel-auth-field' },
            { ...LOGIN_FIELDS.CONFIRM_PASSWORD, placeholder: 'Re-enter new password', className: 'ciel-auth-field' },
        ],
    };

    function debugForm(_form: any) {
        setForm(_form);
        const { newPassword, confirmPassword } = _form.values || {};
        if (newPassword && confirmPassword && newPassword !== confirmPassword) {
            setPasswordError('New password and Re-enter password should be same');
        } else {
            setPasswordError('');
        }
    }

    function isInvalid() {
        return !form.valid || !!passwordError;
    }

    function handleSubmit(event: any) {
        preventDefault(event);
        const { resetToken, newPassword, confirmPassword } = form.values || {};

        if (isInvalid()) {
            if (passwordError) {
                toast.error(passwordError);
            } else {
                toast.error("Please fill all the mandatory fields.");
            }
            return;
        }

        setSubmitting(true);
        changePassword({ newPassword, token: resetToken });
    }

    useEffect(() => {
        clearUserSession();
    }, []);

    return (
        <>
            <div className="row m-0 ciel-auth">
                <div className="col-md-8 p-0 ciel-auth-brand-col">
                    <AuthBrandPanel />
                </div>

                <div className="col-md-4 p-0 ciel-auth-form-col">
                    {
                        !changePwdSuccess ?
                            <div className="ciel-auth-card">
                                <button type="button" className="ciel-auth-back-link" onClick={signIn}>
                                    <img src={backArrow} alt="" />
                                    Back to Login page
                                </button>
                                <div className="ciel-auth-heading">
                                    <h2>Reset Password</h2>
                                </div>
                                <div className="ciel-auth-instructions">
                                    <p className="ciel-auth-instructions-label">Instructions</p>
                                    <p>Enter the reset token you received in your email along with your new password. Password must be at least 12 characters long and must include at least one lowercase letter, one uppercase letter, one digit and one special character. The first character of the password cannot be a special character.</p>
                                </div>
                                <FormRenderer FormTemplate={FormTemplate}
                                    initialValues={{ hideButtons: true }}
                                    componentMapper={ComponentMapper}
                                    schema={schema}
                                    debug={debugForm}
                                />
                                {passwordError && (
                                    <div className="text-error text-center">
                                        <small>{passwordError}</small>
                                    </div>
                                )}
                                <Button
                                    variant="primary"
                                    type="button"
                                    className="btn btn-primary w-100"
                                    disabled={isInvalid()}
                                    onClick={handleSubmit}
                                >
                                    Change Password
                                </Button>
                            </div> :
                            <div className="ciel-auth-card">
                                <div className="d-flex flex-column align-items-center text-center">
                                    <FontAwesomeIcon icon={faCircleCheck} style={{ fontSize: '64px' }} className="mb-3 text-success" />
                                    <div className="ciel-auth-heading">
                                        <h2>Password Changed successfully</h2>
                                        <p>Please log in with the new password.</p>
                                    </div>
                                    <Button variant="primary" type="submit" className="btn btn-primary w-100 mt-4" onClick={signIn}>
                                        Back To LOGIN
                                    </Button>
                                </div>
                            </div>
                    }
                </div>
            </div>
            {submitting && <PageLoader />}
        </>
    )
}

export default ChangePassword;
